import { BehaviorSubject, interval, zip } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import { LoggerService } from '@wdpr/ra-angular-logger';

import { DebugLogService } from '../debug-log/debug-log.service';
import { LazyLoaderService } from '@finder/shared/services/lazy-loader/lazy-loader-service';
import { ScrollimationService } from './scrollimation.service';

declare const gsap: any;
declare const ScrollTrigger: any;

const isGsapScriptLoaded = new BehaviorSubject(false);
const isScrollTriggerScriptLoaded = new BehaviorSubject(false);
const isScriptsReady$ = new BehaviorSubject<boolean>(false);

const GSAP_FILE = 'gsap.js';
const SCROLL_TRIGGER_FILE = 'scroll-trigger.js';

export const ScrollimationFactory = (
    lazyLoaderService: LazyLoaderService,
    debugLog: DebugLogService,
    logger: LoggerService
) => {
    const loadFiles = () => Promise.all([
        lazyLoaderService.lazyLoadScriptResource(GSAP_FILE).toPromise(),
        lazyLoaderService.lazyLoadScriptResource(SCROLL_TRIGGER_FILE).toPromise()
    ]);

    loadFiles()
        .then(() => {
            zip(
                isGsapScriptLoaded,
                isScrollTriggerScriptLoaded
            )
            .pipe(
                switchMap(() => interval(200)),
                filter(() => gsap && ScrollTrigger),
                take(1)
            )
            .subscribe({
                next: () => {
                    gsap.registerPlugin(ScrollTrigger);
                    isScriptsReady$.next(true);
                },
                error: (err) => {
                    const error = new Error(`***** ***** script check failed: ${err}`);
                    debugLog.log(error.message);
                    throw error;
                }
            });
        })
        .catch((err) => {
            const error = new Error(`***** Responder script could not be loaded: ${err}`);
            logger.error(error.message);
        });

    return new ScrollimationService(
        isScriptsReady$.asObservable(),
    );
};
